import React from 'react';
import { Card } from 'react-bootstrap';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import FalconPagination from 'components/common/custom/pagination';
import SubtleBadge from 'components/common/SubtleBadge';

const PatientHistoryTab = ({ title, table, totalRecords }) => {
    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="mb-0 fs-9 fw-bold text-primary">{title}</h5>
                <SubtleBadge bg="primary" pill className="fs-11 px-3 py-2">
                    Total Records: {totalRecords || 0}
                </SubtleBadge>
            </div>
            {totalRecords > 0 ? (
                <div className="border rounded overflow-hidden shadow-sm">
                    <AdvanceTableProvider {...table}>
                        <AdvanceTable
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                hover: true,
                                className: 'fs-10 mb-0'
                            }}
                            headerClassName="bg-200 text-nowrap align-middle py-3"
                            rowClassName="align-middle white-space-nowrap"
                        />
                        <Card.Footer className="d-flex justify-content-end align-items-center py-2">
                            <FalconPagination
                                currentPage={table.getState().pagination.pageIndex}
                                rowsPerPage={table.getState().pagination.pageSize}
                                totalRecords={totalRecords || 0}
                                onPageChange={(page) => table.setPageIndex(page)}
                                onPageSizeChange={(size) => table.setPageSize(size)}
                            />
                        </Card.Footer>
                    </AdvanceTableProvider>
                </div>
            ) : (
                <div className="text-center border py-3">No Data To Show</div>

            )}
        </>
    );
};

export default PatientHistoryTab;
